import axios from "axios";
import Swal from "sweetalert2";

export const getShifts = async (store_id ,currentPage) => {
    try {
      const brear = localStorage.getItem("token");
      console.log('brear', brear)
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/shift-templates",    
        {  params:{store_id, page: currentPage}, headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };
  
export const postShifts = async (postData) => {
    try {
      const brear = localStorage.getItem("token");

      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/shift-templates",   postData,
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

export const updateShifts = async (postData, id) => {
    try {
      const brear = localStorage.getItem("token");

      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        `/v1/admin/shift-templates/${id}`,   postData,
        {headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

export const deleteShifts = async (id) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/shift-templates/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        },
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};
